module.exports = __webpack_public_path__ + "img/Dantam Hair 30.83811420.jpg";